import {useContext} from 'react';
import {DynamicWalletConnectWrapper} from '@stripe-internal/wallet-connect-wrapper';
import {WalletConnectionClientContext} from './WalletConnectionClientContext';

export const useWalletConnectionClient = (): DynamicWalletConnectWrapper => {
  const context = useContext(WalletConnectionClientContext);
  const walletClient = context?.walletClientRef.current;
  if (!walletClient) {
    throw new Error(
      'useWalletConnectionClient must be used within WalletConnectionClientProvider',
    );
  }
  return walletClient;
};
